import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ptBR from '@/locales/pt-br';
import enUS from '@/locales/en-us';
import esES from '@/locales/es-es';

Vue.use(VueI18n);

export default new VueI18n({
    locale: 'pt-BR',
    silentFallbackWarn: true,
    silentTranslationWarn: true,
    messages: {
        'pt-BR': ptBR,
        'en-US': enUS,
        'es-ES': esES,
    },
});